import { User } from '../models/user';

export class UserAdapter {
  static fromServerResponse(userData: any): User {
    return new User(userData);
  }
}
